import React, { memo } from 'react'

import {
  arrayOf, func, shape, string,
} from 'prop-types'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import Categories from './Components/Categories/Categories'
import Search from './Components/Search/Search'
/* import SortDropdown from './Components/SortDropdown/SortDropdown' */

function Filters({
  searchQuery = '',
  onSearchChange = NOOP,
  category = '',
  categories = EMPTY_ARRAY,
  onCategoryChange = NOOP,
}) {
  return (
    <div className="community-gallery-panel__filters">
      <Search value={searchQuery} onChange={onSearchChange} />
      <Categories categories={categories} selected={category} onChange={onCategoryChange} />
      {/* Hiding them for now until we have enough models/data */}
      {/* <div className="community-gallery-panel__filters-divider" /> */}
      {/* <SortDropdown value={sortOrder} options={sortOptions} onChange={onSortChange} /> */}
    </div>
  )
}

Filters.propTypes = {
  searchQuery: string,
  onSearchChange: func,
  category: string,
  categories: arrayOf(shape({
    name: string.isRequired,
    value: string.isRequired,
  })),
  onCategoryChange: func,
}

export default memo(Filters)
